
export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item'
}
export const website = window.$website
export const url = website.url